import * as React from "react";
import {connect} from "react-redux";
import PureGreenImage from "../../assets/images/yellow-button.png";
import {IPureGreenButton} from "../../ScrollyInterface";
import {setStyles} from "../../shared/breakpoints";
import "./PureGreenButton.scss";

const PureGreenButton = (props: IPureGreenButton, {}) => {
	const {
		breakpoint,
		link,
		positions
	} = props;

	const breakPointPositions = setStyles({...positions}, breakpoint)

	return (
		<div className="PureGreenButton" style={breakPointPositions}>
			<a target="_blank" href={link}>
				<img src={PureGreenImage} />
			</a>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	return {
		breakpoint: state.ui.breakpoint,
		link: state.data.content.pureGreenButton.link,
		positions: state.data.content.pureGreenButton.position,
	};
};

export default connect(
	mapStateToProps,
	{}
)(PureGreenButton);


// WEBPACK FOOTER //
// ./src/components/Buttons/PureGreenButton.tsx